import React, { useState } from 'react';
import ReactApexChart from 'react-apexcharts';

const WeeksProfit = ({ className, dashboardData }) => {
  const [timeFrame, setTimeFrame] = useState('this week');

  // Use property types data or fallback
  const propertyTypes = dashboardData?.propertyTypes || [
    { name: 'Single Family', count: 45, value: 35 },
    { name: 'Multi Family', count: 80, value: 28 },
    { name: 'Condo', count: 60, value: 22 },
    { name: 'Commercial', count: 70, value: 15 },
  ];

  // Use top locations for weekly data
  const locations = dashboardData?.locations?.slice(0, 7) || [];
  
  const salesData = locations.length > 0 
    ? locations.map((loc, i) => ({ 
        x: loc.county?.split(' ')[0] || `Area ${i+1}`, 
        y: Math.round(loc.properties || 0) 
      }))
    : [
        { x: 'Gloucester', y: 45 },
        { x: 'Bergen', y: 80 },
        { x: 'Hudson', y: 60 },
        { x: 'Essex', y: 70 },
        { x: 'Union', y: 35 },
        { x: 'Morris', y: 70 },
        { x: 'Somerset', y: 80 },
      ];

  const revenueData = salesData.map(d => ({ 
    x: d.x, 
    y: Math.round(d.y * 0.6) // Revenue as 60% of sales
  }));

  const options = {
    colors: ['#5750F1', '#0ABEF9'],
    chart: {
      type: 'bar',
      stacked: true,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    responsive: [
      {
        breakpoint: 1536,
        options: {
          plotOptions: {
            bar: {
              borderRadius: 3,
              columnWidth: '25%',
            },
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 3,
        columnWidth: '25%',
        borderRadiusApplication: 'end',
        borderRadiusWhenStacked: 'last',
      },
    },
    dataLabels: {
      enabled: false,
    },
    grid: {
      strokeDashArray: 5,
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    xaxis: {
      categories: salesData.map(d => d.x),
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left',
      fontFamily: 'inherit',
      fontWeight: 500,
      fontSize: '14px',
      markers: {
        size: 9,
        shape: 'circle',
      },
    },
    fill: {
      opacity: 1,
    },
  };

  const series = [
    {
      name: 'Sales',
      data: salesData.map(d => d.y),
    },
    {
      name: 'Revenue',
      data: revenueData.map(d => d.y),
    },
  ];

  return (
    <div
      className={`rounded-10 bg-white px-7.5 pt-7.5 shadow-1 dark:bg-gray-dark dark:shadow-card ${className || ''}`}
    >
      <div className="flex flex-wrap items-center justify-between gap-4">
        <h2 className="text-body-2xlg font-bold text-dark dark:text-white">
          Properties by County
        </h2>

        <select
          value={timeFrame}
          onChange={(e) => setTimeFrame(e.target.value)}
          className="rounded border border-stroke px-3 py-1 text-sm font-medium dark:border-dark-3 dark:bg-dark-2"
        >
          <option value="this week">This Week</option>
          <option value="last week">Last Week</option>
        </select>
      </div>

      <div className="-ml-3.5 mt-3">
        <ReactApexChart
          options={options}
          series={series}
          type="bar"
          height={370}
        />
      </div>
    </div>
  );
};

export default WeeksProfit;
